import React from "react";
import PropTypes from "prop-types";
import styles from "./ReportButton.module.css";

const ReportButton = ({ label, disabled, isLoading, onClick }) => {
  const getButtonClass = () => {
    if (disabled) return styles.disabled;
    switch (label) {
      case "Generate PDF":
        return styles.generatePDF;
      case "Generate Report":
        return styles.generateReport;
      case "Save Report":
        return styles.saveReport;
      default:
        return styles.default;
    }
  };

  const isDisabled = disabled || isLoading;

  return (
    <button
      className={`${styles.button} ${getButtonClass()}`}
      disabled={isDisabled}
      aria-busy={isLoading ? "true" : "false"}
      aria-live="polite"
      onClick={onClick}
    >
      {isLoading ? (
        <>
          <span className={styles.spinner} />
          <span className={styles.label}>{label}</span>
        </>
      ) : (
        label
      )}
    </button>
  );
};

ReportButton.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
};

export default ReportButton;
